<template>
  <v-row justify="center">
    <v-col class="mb-10" cols="12" sm="11" md="8" lg="7">
      <v-card outlined class="title pa-10 lineheight130">
        <p class="text-center text-h4 pb-4">
          公益財団法人ヤマハ発動機スポーツ振興財団<br />
          2022年度 スポーツ教材の提供の申請確認
        </p>
        <p class="pb-2">
          2022年度 スポーツ教材の提供の申請を受け付けました。<br />
          受付NO．は、 {{ id }} 番です。
        </p>
        <div class="pb-4">
          申請いただきました内容を、記入いただいたメールアドレス宛にお送りしました。<br />
          申請後2～3日たってもメールが届かない場合には、事務局までお問い合わせください。<br />
          <div class="text-right">TEL 0538-32-9827</div>
        </div>
        <p>抽選の正式な結果は、 以下の方法にてお知らせいたします。</p>
        <v-row class="pb-6">
          <v-col lg="3" md="4" sm="5"> ・5月17日（火）9時 </v-col>
          <v-col>
            ・ホームページにて提供先団体の発表<br />
            https://www.ymfs.jp/
            <br />・提供先に決定した団体宛てにはメール送信<br />
          </v-col>
        </v-row>
        <p class="pb-2">
          申請内容に修正が生じた場合には、事務局にて修正を行いますので、メールまたはお電話にてご連絡ください。
        </p>

        <p class="text-center pb-4">
          公益財団法人ヤマハ発動機スポーツ振興財団 事務局 担当 濱北 <br />
          <span class="pr-4">TEL 0538-32-9827</span
          ><span class="pl-4"> E-Mail webmaster@ymfs.jp</span>
        </p>
        <div class="text-center">
          <v-btn class="primary" to="/">申請フォームトップへ戻る</v-btn>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
export default {
  name: "KyoikuInputDone",
  data() {
    return {
      id: "",
    };
  },
  mounted() {
    let temp = JSON.parse(window.localStorage.getItem("temp_kyouiku_id"));
    if (!temp) {
      this.$router.push("/");
      return false;
    }
    this.id = temp.id;
    temp = JSON.parse(window.localStorage.getItem("temp_kyouiku_1"));
    if (!temp) {
      this.$router.push("/");
      return false;
    }
    temp = JSON.parse(window.localStorage.getItem("temp_kyouiku_2"));
    if (!temp) {
      this.$router.push("/");
      return false;
    }
    temp = JSON.parse(window.localStorage.getItem("temp_kyouiku_3"));
    if (!temp) {
      this.$router.push("/");
      return false;
    }
    window.localStorage.clear();
  },
};
</script>
<style >
.lineheight130 {
  line-height: 180% !important;
}
.center-item-2 {
  display: flex;
  justify-content: center;
  position: relative;
}
.center-item-2-right {
  line-height: 50px;
  position: absolute;
  right: 0;
}
</style>